<template>
    <card>
       <template slot="header">
          <h3 class="card-title">Leave Details</h3>
       </template>
       <div class="row">
          <nav>
             <ol class="breadcrumb arr-right bg-breadcrum">
                <li class="breadcrumb-item">
                   <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                </li>
                <li class="breadcrumb-item">
                   <router-link to="/hr/absenceleave">Leave & Absences Record</router-link>
                </li>
                <li class="breadcrumb-item active">Leave Details</li>
             </ol>
          </nav>
       </div>
       <hr style="margin-top:-10px"/>
       <div class="report-container" id="printme">
            <img class="logo-print" width="190" height="110" src="/static/img/blueprintlogo.png" alt="..."/><br/><br/>
            <span class="float-right"><img width="30" height="30" id="printIcon" onclick="window.print()" src="/static/img/print.png" alt="..." /></span><br/><br/>
          <div class="report-border-full">
             <div class="report-header">
                LEAVE APPLICATION FORM
             </div>
          </div>
          <div class="report-gatter"></div>
          <div class="col-md-12 report-border-full">
             <div class="row">
                <div class="col-md-6 b-border">
                   <p class="margin-p"><b>Employee Name:</b> {{item.full_name}}</p>
                   <p class="margin-p"><b>Department:</b> {{item.department_name | capitalize}}</p>
                </div>
                <div class="col-md-6">
                   <p class="margin-p"><b>Employee Number:</b> {{item.emp_id}}</p>
                   <p class="margin-p"><b>Position:</b> {{item.position_name | capitalize}}</p>
                </div>
             </div>
          </div>
          <div class="report-gatter"></div>
          <div class="col-md-12 report-border-full">
             <div class="row">
                <div class="col-md-12">
                   <p class="margin-p"><b>Date Filled :</b> {{item.date_filled}}</p>
                </div>
                <div class="col-md-12">
                   <p class="margin-p"><b>Type of Leave :</b> {{item.leave_type}}</p>
                </div>
                <div class="col-md-12">
                   <p class="margin-p"><b>Total Days:</b> {{item.no_of_days}}</p>
                </div>
                <div class="col-md-12">
                   <p class="margin-p"><b>Start Date :</b> {{item.start_date}}</p>
                </div>
                <div class="col-md-12">
                   <p class="margin-p"><b>End Date :</b> {{item.end_date}}</p>
                </div>
             </div>
          </div>
          <div class="report-gatter"></div>
          <div class="col-md-12 report-border-full">
             <div class="row">
                <div class="col-md-12">
                   <p class="margin-p"><b>Reason for Leave / Absent :</b><br/> {{item.reason}}</p>
                </div>
             </div>
          </div>
          <form @submit="update_leave">
             <div v-if="item.roles === 1 && item.belongs_to != 0">
                <b>Departmental Approval</b>
                <div class="report-gatter"></div>
                <div class="col-md-12 report-border-full">
                   <!-- TL --> 
                   <div class="row">
                      <div class="col-md-4">
                         <p class="margin-p"><b>Supervisor Name:</b></p>
                         {{item.supervisor}}
                      </div>
                      <div class="col-md-4">
                         <p class="margin-p"><b>Supervisor Approval:</b></p>
                         {{item.tl_status}}
                      </div>
                      <div class="col-md-4">
                         <p class="margin-p"><b>Date Approved:</b></p>
                         {{item.tl_date_approved}}
                      </div>
                   </div>
                   <!-- END -->  
                   <!-- ASM -->
                   <div class="row">
                      <div class="col-md-4">
                         <p class="margin-p"><b>Departmental Head's Name:</b></p>
                         {{item.department_head}}
                      </div>
                      <div class="col-md-4">
                         <p class="margin-p"><b>Departmental Head Approval:</b></p>
                         {{item.asm_status | capitalize}}
                      </div>
                      <div class="col-md-4">
                         <p class="margin-p"><b>Date Approved:</b></p>
                         {{item.asm_date_approved}}
                      </div>
                   </div>
                   <!-- END -->   
                </div>
             </div>
             <div v-if="item.roles === 2">
                <b>Departmental Approval</b>
                <div class="report-gatter"></div>
                <div class="col-md-12 report-border-full">
                   <!-- ASM -->
                   <div class="row">
                      <div class="col-md-4">
                         <p class="margin-p"><b>Departmental Head's Name:</b></p>
                         {{item.department_head}}
                      </div>
                      <div class="col-md-4">
                         <p class="margin-p"><b>Departmental Head Approval:</b></p>
                         {{item.asm_status | capitalize}}
                      </div>
                      <div class="col-md-4">
                         <p class="margin-p"><b>Date Approved:</b></p>
                         {{item.asm_date_approved}}
                      </div>
                   </div>
                   <!-- END -->   
                </div>
             </div>
             <b>HR Department Approval</b>
             <div class="report-gatter"></div>
             <div class="col-md-12 report-border-full">
                <div class="row">
                   <div class="col-md-4">
                      <p class="margin-p"><b>Remarks:</b></p>
                      {{item.remarks}}
                   </div>
                   <!-- <slot v-if="item.status == 'pending'">   -->
                   <div class="col-md-4">
                      <p class="margin-p"><b>HR Approval:</b></p>
                      {{item.status | capitalize}}
                   </div>
                   <div class="col-md-4">
                      <p class="margin-p"><b>Date Recived:</b></p>
                      {{item.hr_date_recived}}
                   </div>
                </div>
             </div>
          </form>
      </div>
       <br/>
       <br/>
    </card>
 </template>
  <script>
  /* eslint-disable */
     import Card from 'src/components/UIComponents/Cards/Card.vue'  
     export default {
  components: {
    Card
  },
  data() {
    return {
      item: {}
    };
  },
  mounted: function() {
    this.getItem();
    this.getCurentUser();
  },
  methods: {
  
    getItem() {
      axios
        .get("api/leaveabsences/get/" + this.$route.params.id)
        .then(response => {
          this.item = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    update_leave(e) {
      e.preventDefault();
      axios
        .post(
          "api/leaveabsences/update/hr/" + this.item.id,
          {
            date_filled: this.item.date_filled,
            no_of_days: this.item.no_of_days,
            leave_type: this.item.leave_type,
            remarks: this.item.remarks,
            start_date: this.item.start_date,
            end_date: this.item.end_date,
            reason: this.item.reason,
            status: this.item.status,
            hr_date_recived: this.item.hr_date_recived
          }
        )
        .then(response => {
          this.$swal({
            type: "success",
            title: "Approved",
            html:
              "Employee leave has been  <br/>successfully approved <br/><br/>",
            showConfirmButton: false,
            timer: 4000
          });
          this.$router.push({
            name: "absence-leave"
          });
          console.log(response.data);
        })
        .catch(e => {
          console.log(e.response);
        });
    }
  },

};
</script>

<style media="all">
    #printIcon{
      cursor: pointer;
    }


    @media print {    
     #printIcon  {
       display: none;
     }

    body * { 
     visibility: hidden; 
    } 
     
     .report-container{
      position: fixed;
       top:0;
       width: auto;
     }

     .report-header{
      margin: auto 30% !important;
      font-size: 25px;
     }

     #printme, #printme * { 
      visibility: visible; 
    }
  }

  </style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-leave-management/todo-view-leave.vue